import WebApp from '@twa-dev/sdk';

import { type StartAppArgs } from '@/shared/stores/app-store/types';

import { base64Utils } from '../base64-utils';

export const getDecodedStartappQuery = (): StartAppArgs => {
  let args = {} as StartAppArgs;

  try {
    const urlSearch = new URLSearchParams(window.location.search);

    const pdTmaFromQuery = urlSearch.get('pdTma'); // pdTma из URL параметров
    const encodedQueryFromUrl1 = urlSearch.get('startapp'); // получение стартапов из replay_keyboard ИЛИ при запуске из маркета ИЛИ tg web
    const encodedQueryFromUrl2 = urlSearch.get('tgWebAppStartParam'); // иногда либа неотвечает, так что берём нарпямую
    const encodedTGParams = WebApp?.initDataUnsafe?.start_param; // навсякий обращаемся в тг либе

    const encodedArgs = encodedQueryFromUrl1 || encodedQueryFromUrl2 || encodedTGParams;

    if (encodedArgs) {
      const decodedArgs = base64Utils.decode<StartAppArgs>(encodedArgs);
      const isString = typeof decodedArgs === 'string';
      if (isString) {
        args = { ...args, ...{} };
      } else {
        args = { ...args, ...decodedArgs };
      }

      // HACK: The standalone bot receives URL params from console.paysystem.io/short-urls
      // which override the params from the original URL.
      // As a workaround, we add tg?.WebApp?.initDataUnsafe?.start_param.
      // https://fantasyinvest.flowfast.io/space/79846/boards/card/6644912
      if (pdTmaFromQuery && encodedTGParams) {
        const decodedTGParams = base64Utils.decode<StartAppArgs>(encodedTGParams);
        const isString = typeof decodedTGParams === 'string';

        if (isString) {
          args = { ...args, ...{} };
        } else {
          args = { ...args, ...decodedTGParams };
        }
      }
    }
  } catch (err) {
    console.error(err);
  }

  return args;
};
